/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { getFileListHeaders, getFilesRegistry } from '@nextcloud/files';
import { computed, ref } from 'vue';
const headers = ref();
const sorted = computed(() => [...(headers.value ?? [])].sort((a, b) => a.order - b.order));
/**
 * Get the registered and sorted file list headers.
 */
export function useFileListHeaders() {
    if (!headers.value) {
        // if not initialized by other component yet, initialize and subscribe to registry changes
        headers.value = getFileListHeaders();
        getFilesRegistry().addEventListener('register:listHeader', () => {
            headers.value = getFileListHeaders();
        });
    }
    return sorted;
}
